/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORD,
  LOAD_RECORDS,
  CREATE_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,
  LOAD_RECORDS_META_DATA,
  UPDATE_STATUS,
  LOAD_EQUIPMENT_MASTER,
} from "./constants"

import {
  loadRecords as loadRecordsAction,
  loadRecordsSuccess,
  loadRecordsError,
  loadRecordSuccess,
  loadRecordError,
  createRecordSuccess,
  createRecordError,
  updateRecordSuccess,
  updateRecordError,
  deleteRecordSuccess,
  deleteRecordError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  updateStatusSuccess,
  updateStatusError,
  loadEquipmentMasterSuccess,
  loadEquipmentMasterError,
  loadEquipmentMaster,
} from "./actions"

import {
  loadRecords,
  loadRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  loadRecordsMetaData,
  updateStatus,
  loadEquipmentMasterDetails,
} from "./remotes"

import { selectRecords } from "./selectors"

function* loadRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORDS),
    })

    const { explicitLoad } = load
    const { searchFilter } = explicitLoad || {}
    yield put(loadRecordsAction(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecords, searchFilter)
        if (result) {
          yield put(loadRecordsSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadRecordsSuccess([]))
          yield put(loadRecordsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadRecordsSuccess([]))
        yield put(
          loadRecordsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const loadRequest = yield race({
      request: take(LOAD_RECORD),
    })
    const { request } = loadRequest

    if (request) {
      const { id } = request

      try {
        const record = yield call(loadRecord, id)

        let recordsMetaData = {}
        if (record) {
          // Delays the dispatch of loadRecordSuccess untill the store is populated with an initial list of records.
          while (true) {
            // eslint-disable-line no-constant-condition
            const recordsInStore = yield select(selectRecords())
            if (recordsInStore && recordsInStore.length > 0) {
              break
            }
            yield delay(500)
          }
          yield put(loadRecordSuccess(record, recordsMetaData))
        } else {
          yield put(loadRecordError("Fetch Record Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordError(
            (error && error.response && error.response.message) ||
              "Fetch Record Failed"
          )
        )
      }
    }
  }
}

function* createRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_RECORD),
    })
    const { record } = create || {}
    if (create) {
      // yield call(setSubmitting, true)
      try {
        const result = yield call(createRecord, record)
        yield put(createRecordSuccess(record))
        if (result) {
          yield put(createRecordSuccess(record))
        } else {
          yield put(createRecordError("Create Record Failed"))
        }
      } catch (error) {
        yield put(
          createRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* editRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_RECORD),
    })
    const { record } = edit || {}
    if (edit) {
      //yield call(setSubmitting, true)
      console.log(record, "coneeeeeeeeeeeeeeeeeee")
      try {
        yield call(updateRecord, record)
        yield delay(1000)
        yield put(updateRecordSuccess(record, "Record Updated Successfully"))
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      }
    }
  }
}

function* deleteRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_RECORD),
    })
    const { deleteData } = create || {}
    console.log(create, "resulttt")
    if (create) {
      // yield call(setSubmitting, true)
      try {
        yield call(deleteRecord, deleteData)

        yield delay(1000)
        yield put(deleteRecordSuccess(deleteData))
        yield put(true)
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* loadEquipmentMasterSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EQUIPMENT_MASTER),
    })

    const { explicitLoad } = load

    const { companyId, branchId } = explicitLoad || {}
    yield put(loadEquipmentMaster(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadEquipmentMasterDetails,
          companyId,
          branchId
        )
        console.log("api result is", result)
        yield put(loadEquipmentMasterSuccess(result.data))
        console.log(result.data)
      } catch (error) {
        yield put(
          loadEquipmentMasterError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let company = yield call(loadRecordsMetaData, "company", "post")
      let branch = yield call(loadRecordsMetaData, "branch", "post")

      const equipmentMaster = yield call(
        loadRecordsMetaData,
        "equipment_master",
        "post"
      )
      const equipmentBrandName = yield call(
        loadRecordsMetaData,
        "equipment_brand",
        "post"
      )
      const equipmentBrand = yield call(
        loadRecordsMetaData,
        "equipment_brand",
        "post"
      )
      const equipmentTypeName = yield call(
        loadRecordsMetaData,
        "equipment_type",
        "post"
      )
      const equipmentProduct = yield call(
        loadRecordsMetaData,
        "product_version",
        "post"
      )
      let permissionMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],

        equipmentMasterOptions:
          (equipmentMaster &&
            equipmentMaster.data &&
            equipmentMaster.data.length > 0 &&
            equipmentMaster.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    // label: p.equipmentName,
                    label: p.serialNumber,
                    value: p._id,
                    // companyId: p.companyId,
                    // branchId: p.branchId,
                    equipmentBrandId: p.equipmentBrandId,
                    equipmentTypeId: p.equipmentTypeId,
                    equipmentTypeName: p.equipmentTypeName,
                    equipmentBrandName: p.equipmentBrandName,
                    equipmentName: p.equipmentName,
                    productVersionId: p.productVersionId,
                    productVersionName: p.productVersionName,
                    equipmentCode: p.equipmentCode,
                    serialNumber: p.serialNumber,
                  }
                )
              )) ||
          [],
        brandEquipmentOptions:
          (equipmentMaster &&
            equipmentMaster.data &&
            equipmentMaster.data.length > 0 &&
            equipmentMaster.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.equipmentBrandName,
                    value: p._id,
                  }
                )
              )) ||
          [],
        equipmentTypeOptions:
          (equipmentMaster &&
            equipmentMaster.data &&
            equipmentMaster.data.length > 0 &&
            equipmentMaster.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.equipmentTypeName,
                    value: p._id,
                  }
                )
              )) ||
          [],
        equipmentProductOptions:
          (equipmentMaster &&
            equipmentMaster.data &&
            equipmentMaster.data.length > 0 &&
            equipmentMaster.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.productVersionName,
                    value: p._id,
                  }
                )
              )) ||
          [],
        productOptions:
          (equipmentProduct &&
            equipmentProduct.data &&
            equipmentProduct.data.length > 0 &&
            equipmentProduct.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.productVersion,
                    value: p._id,
                  }
                )
              )) ||
          [],
        typeOptions:
          (equipmentTypeName &&
            equipmentTypeName.data &&
            equipmentTypeName.data.length > 0 &&
            equipmentTypeName.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.equipmentType,
                    value: p._id,
                  }
                )
              )) ||
          [],
        equipmentBrandOptions:
          (equipmentBrandName &&
            equipmentBrandName.data &&
            equipmentBrandName.data.length > 0 &&
            equipmentBrandName.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.brand,
                    value: p._id,
                    equipmentBrandName: p.equipmentBrandName,
                  }
                )
              )) ||
          [],
        brandOptions:
          (equipmentBrand &&
            equipmentBrand.data &&
            equipmentBrand.data.length > 0 &&
            equipmentBrand.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.equipmentBrand,
                    value: p._id,
                  }
                )
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* updateStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = update
    yield call(setSubmitting, true)

    try {
      const result = yield call(updateStatus, record)
      if (result) {
        yield put(updateStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
      } else {
        yield put(updateStatusError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateStatusError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordSaga(),
    loadRecordsSaga(),
    createRecordSaga(),
    editRecordSaga(),
    deleteRecordSaga(),
    loadRecordsMetaDataSaga(),
    updateStatusSaga(),
    loadEquipmentMasterSaga(),
  ])
}
